$(document).ready(function () {


  $(document).on("click", ".prd_dynamic_cart_fx", function (e) {
    e.preventDefault();
  
    var $btn = $(this);
    var varId = $btn.data("varid");
  
    // Add loading class
    $btn.addClass("is--loading");
  
    // Example AJAX request
    $.ajax({
      url: "/cart/add.js",
      type: "POST",
      data: {
        id: varId,
        quantity: 1
      },
      dataType: "json",
      success: function (res) {
        // Fetch updated cart
        $.getJSON("/cart.js", function (cart) {
          // Update header cart count
          $("span[data-header-cart-count]").text(cart.item_count);
        });
  
        $btn.removeClass("is--loading");
      },
      error: function (xhr) {
        console.error("Error:", xhr);
  
        // Remove loading class on error too
        $btn.removeClass("is--loading");
      }
    });
  });
  
  
  //Site 1 Marquee slider
      if($("#slider--top").length != 0) {
  
          new Splide("#slider--top", {
              type: "loop",
              autoWidth: true,
              autoplay: true,
              interval: 1,
              speed: 100000,
              direction: "ltr",
              arrows: false,
              pagination: false,
              pauseOnHover: false,
              pauseOnFocus: false,
              gap: '50px'
          }).mount();
      }
  //Site 1 Featured collection product slider
      if($(".prod-slider").length != 0) {
  
      new Splide('.prod-slider', {
       type: "loop",
      perPage: 3,
      autoplay: true,
       interval: 5000,
      gap: '100px',
      arrows: true,
      pagination: false,
      breakpoints: {
        768: { perPage: 1 },
        1024: { perPage: 3 }
      }
    }).mount();
  }
  
    
  // Testimonials Video Slider
      var $videosGrid = $(".reviews-sec .videos-grid");
      if ($videosGrid.length !== 0) {
        var isDual = $videosGrid.hasClass("dual");
        var mobilePerPage = isDual ? 2 : 1;
        new Splide(".reviews-sec .videos-grid", {
          perPage: 4,
          drag: false,
          dragAngleThreshold: 0,
          gap: "55px",
          arrows: true,
          autoplay: false,
          pagination: true,
          breakpoints: {
            500: {
              perPage: mobilePerPage,
              drag: true
            },
            820: {
              perPage: 2,
              drag: true,
              gap: "45px"
            },
            1200: {
              perPage: 3,
              drag: false,
              gap: "55px",
            }
          }
        }).mount();
      }
  
  
  //TEstimonaials Review Slider 
      if($(".testimonials-slider").length != 0) {
  
     new Splide('.testimonials-slider', {
          perPage: 3,
          gap: '45px',
          arrows: true,
          autoplay: false,
           interval: 1000,
          pagination: false,
          breakpoints: {
              768: { perPage: 1 },
              1024: { perPage: 2 }
          }
      }).mount();
  }
  
      if($(".reviews-sec").length != 0) {
  
          //TEstimonaials On play button click play video and overlay
          document.querySelectorAll(".reviews-sec").forEach(function (reviewsSec) {
          const videos = reviewsSec.querySelectorAll(".video-element");
  
          videos.forEach(function (video) {
              let overlay = video.parentElement.querySelector(".overlay-content");
  
              if (overlay) {
              // Function to pause other videos
              function pauseOthers() {
                  videos.forEach(function (otherVideo) {
                  if (otherVideo !== video) {
                      otherVideo.pause();
                      let otherOverlay = otherVideo.parentElement.querySelector(".overlay-content");
                      if (otherOverlay) otherOverlay.style.display = "";
                  }
                  });
              }
  
              // Click overlay → play video + hide overlay
              overlay.addEventListener("click", function () {
                  pauseOthers();
                  video.play();
                  overlay.style.display = "none";
              });
  
              // Click video → toggle pause/play
              // video.addEventListener("click", function () {
              //     if (!video.paused) {
              //     // Pause current video and restore overlay
              //     video.pause();
              //     overlay.style.display = "";
              //     }
              // });
  
              // When video pauses → show overlay
              video.addEventListener("pause", function () {
                  overlay.style.display = "";
              });
  
              // When video ends → show overlay again
              video.addEventListener("ended", function () {
                  overlay.style.display = "";
              });
              }
          });
          });
      }
  
      //Custom Search icon header on click trigger search form
      if($(".site1_header_serach_frm .site-search-handle").length != 0) {
          document.querySelector('.site1_header_serach_frm .site-search-handle')?.addEventListener('click', function (e) {
              e.preventDefault();
                  const mobileSearchElements = document.querySelectorAll('.site1_pages .mobile-left-icons .site-search-handle');
                  
                  if (mobileSearchElements.length > 0) {
                  
                      mobileSearchElements.forEach(el => {
                          
                          el.dispatchEvent(new MouseEvent('click', {
                              bubbles: true,
                              cancelable: true,
                              view: window
                          }));
                      });
                  }
  
          });
      }
  });
  
  
  gsap.registerPlugin(ScrollTrigger);
   
  gsap.fromTo(
      [".point-1", ".point-2", ".point-3"],
      { x: -50, opacity: 0 },
      {
          x: 0,
          opacity: 1,
          duration: 0.6,
          stagger: 0.3,
          ease: "power2.out",
          scrollTrigger: {
              trigger: ".prod-left",
              start: "top 80%",  
              toggleActions: "play none none none",
             
          }
      }
  );
   
  gsap.fromTo(
      [".point-4", ".point-5", ".point-6"],
      { x: 50, opacity: 0 },
      {
          x: 0,
          opacity: 1,
          duration: 0.6,
          stagger: 0.3,
          ease: "power2.out",
          delay: 0.9,
          scrollTrigger: {
              trigger: ".prod-left",
              start: "top 80%",
              toggleActions: "play none none none",
             
          }
      }
  );
  
  gsap.registerPlugin(ScrollTrigger);
  
  gsap.utils.toArray('.shopify-section').forEach(section => {
    const headings = section.querySelectorAll('h2');
    
    headings.forEach(heading => {
      gsap.from(heading, {
        opacity: 0,
        y: 30,
        duration: 1,
        scrollTrigger: {
          trigger: heading,       
          start: "top 80%",       
          toggleActions: "play none none none"
        }
      });
    });
  });
  
  
  
  $(document).ready(function () {
      if($("#thumbnail-slider").length != 0) {
          var thumbs = new Splide('#thumbnail-slider', {
             perPage: 5,
              fixedWidth   : 80,
              fixedHeight  : 80,
              gap          : 10,
              pagination   : false,
              direction    : 'ttb',   // vertical
              height       : '500px',
              focus        : 0,  // first thumb at top (no blank when some slides hidden by variant)
              isNavigation : true,    
              breakpoints: {
              820: { perPage: 4, height : '400px', },
              767: {  direction    : 'ltr', perPage: 4, height : 'auto' }
          } 
      
          });
  
          thumbs.on('moved', function (newIndex) {
              // get the active slide
              var activeSlide = thumbs.Components.Slides.getAt(newIndex).slide;
              var mediaId = activeSlide.getAttribute('data-mediaId');
              var targetBtn = document.querySelector(
                  '.product-gallery__thumbnails button[data-mediaId="' + mediaId + '"]'
              );
  
              if (targetBtn) {
                  targetBtn.click();
                  console.log('Triggered click on button with mediaId:', mediaId);
              }
  
              // NEW: also force the main image to update (css-slider aware)
              var imgEl = activeSlide.querySelector('img');
              var srcEl = imgEl && (imgEl.currentSrc || imgEl.src);
              if (srcEl && window._site1ActivateMainByImgSrc) {
                  window._site1ActivateMainByImgSrc(srcEl);
              }
          });
  
          thumbs.mount();
          window._site1Thumbs = thumbs;
  
              if (typeof mediaactiveId !== 'undefined' && mediaactiveId) {
              
                  // Auto-activate current variant media
                      var targetIndex = [...document.querySelectorAll('#thumbnail-slider .splide__slide')]
                      .findIndex(el => el.dataset.mediaId === mediaactiveId);
                      if (targetIndex >= 0) {
                      thumbs.go(targetIndex);
                      }
                  }
      }
  });
  
  /* NEW: Sync main image when any native product thumbnail is clicked */
  document.addEventListener('click', function(e){
    var btn = e.target.closest('.product-gallery__thumbnails button');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var mediaId = btn.getAttribute('data-mediaId') || btn.getAttribute('data-media-id') || btn.getAttribute('data-mediaid');
    if (mediaId && window._site1ActivateMainByMediaId) {
      if (window._site1ActivateMainByMediaId(mediaId, btn)) return;
    }
    var img = btn.querySelector('img');
    var src = img && (img.currentSrc || img.src);
    if (src && window._site1ActivateMainByImgSrc){
      window._site1ActivateMainByImgSrc(src);
    }
  });
  
  /* NEW: Also handle clicks inside our Splide thumbnail rail (left thumbnails use variant id) */
  document.addEventListener('click', function(e){
    var slide = e.target.closest('#thumbnail-slider .splide__slide');
    if (!slide) return;
    e.preventDefault();
    e.stopPropagation();
    var mediaId = slide.getAttribute('data-mediaId') || slide.getAttribute('data-media-id') || slide.getAttribute('data-mediaid');
    if (mediaId && window._site1ActivateMainByMediaId) {
      if (window._site1ActivateMainByMediaId(mediaId, slide)) return;
    }
    var img = slide.querySelector('img');
    var src = img && (img.currentSrc || img.src);
    if (src && window._site1ActivateMainByImgSrc){
      window._site1ActivateMainByImgSrc(src);
    }
  });
  
      // modal
        const modal = document.getElementById('cm_modal');
        const closeEls = modal.querySelectorAll('[data-close]');
        let lastFocused = null;
  
        const FOCUSABLE = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex]:not([tabindex="-1"])';
  
        function openCmModal(selector_content) {
          if(selector_content){
              
              const selector_contentEl = document.querySelector(selector_content);
              const cm_modal__content = document.querySelector('.cm_modal__content');
              cm_modal__content.innerHTML="";
              if(selector_contentEl){
                    cm_modal__content.innerHTML=selector_contentEl.innerHTML;
              }
          }
          lastFocused = document.activeElement;
          modal.classList.add('is-open');
          modal.removeAttribute('aria-hidden');
          // move focus inside
          const first = modal.querySelector(FOCUSABLE);
          if (first) first.focus();
          document.addEventListener('keydown', onCmKeydown);
        }
  
        function closeCmModal() {
          modal.classList.remove('is-open');
          modal.setAttribute('aria-hidden', 'true');
          document.removeEventListener('keydown', onCmKeydown);
          if (lastFocused) lastFocused.focus();
        }
  
        function onCmKeydown(e) {
          if (e.key === 'Escape') return closeCmModal();
          if (e.key === 'Tab') trapCmFocus(e);
        }
  
        function trapCmFocus(e) {
          const focusables = modal.querySelectorAll(FOCUSABLE);
          if (!focusables.length) return;
          const first = focusables[0];
          const last = focusables[focusables.length - 1];
          if (e.shiftKey && document.activeElement === first) {
            e.preventDefault();
            last.focus();
          } else if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault();
            first.focus();
          }
        }
  
        closeEls.forEach(el => el.addEventListener('click', closeCmModal));
        // Prevent clicks inside the dialog from bubbling to overlay
        modal.querySelector('.cm_modal__dialog').addEventListener('click', (e) => e.stopPropagation());
        // Clicking overlay closes
        modal.addEventListener('click', (e) => {
          if (e.target.hasAttribute('data-close')) closeCmModal();
        });
  
  
  //Add to cart custom with subcription plan
  
  document.addEventListener("DOMContentLoaded", function () {
    const qtyDropdowns = document.querySelectorAll(".cm-variant-qty");

    qtyDropdowns.forEach(function (dropdown) {
      dropdown.addEventListener("change", function (e) {
        updatePgbarFromQty();
      });
    });

    function updatePgbarFromQty() {
      const pgbar_response = document.querySelector("#pgbar_response");
      if (!pgbar_response) return;
      const currentquantity = parseInt(pgbar_response.getAttribute("data-cartcount"), 10) || 0;
      let hasValidQty = 0;
      document.querySelectorAll(".cm-variant-qty").forEach(function (qtyInput) {
        const qty = parseInt(qtyInput.value, 10) || 0;
        if (qty > 0) hasValidQty = hasValidQty + qty;
      });
      pgbar_response.setAttribute("data-cartcount", hasValidQty + currentquantity);
    }

    // Delegated listener so quantity changes work even when grid is rendered after DOMContentLoaded
    document.addEventListener("change", function (e) {
      if (!e.target.matches || !e.target.matches(".cm-variant-qty")) return;
      updatePgbarFromQty();
    });
  
  
  
  
  
    document.querySelectorAll(".cm-add-to-cart").forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        document.querySelectorAll('.custom-error-message').forEach(el => el.remove());
  
        // 1. Find parent form
        const form = btn.closest("form");
        if (!form) return;
        // Check Recharge widget radio buttons
        const rcInput = form.querySelector(".rc_widget__option__input:checked");
        const inputContainer = form.querySelector(".cm-variants-grid-container");
        if(inputContainer){
          inputContainer.classList.remove("is--error");
        }
        let sellingplan = "";
  
        // If Recharge radio buttons exist
        if (rcInput) {
          if (rcInput.value == "onetime") {
            sellingplan = ""; // force one-time → no selling plan
          } else {
            // fallback to dropdown selection
            const dropdown = form.querySelector("select.rc-selling-plans__dropdown");
            sellingplan = dropdown ? dropdown.value : "";
          }
        } else {
          // No radio widget, fallback to dropdown
          const dropdown = form.querySelector("select.rc-selling-plans__dropdown");
          sellingplan = dropdown ? dropdown.value : "";
        }
  
      
  
        let hasValidQty = false;
        let items = [];
  
        // 3. Loop over all qty inputs
        form.querySelectorAll(".cm-variant-qty").forEach(function (qtyInput) {
          const qty = parseInt(qtyInput.value, 10) || 0;
          const itemIndex = qtyInput.getAttribute("data-index");
          const itemWrapper = qtyInput.closest(".cm-variant-item");
          const variantId = itemWrapper ? itemWrapper.getAttribute("data-variant-id") : null;
  
          if (!variantId) return;
  
          if (qty > 0) {
            hasValidQty = true;
             let item = {
              id: variantId,
              quantity: qty
            };
  
            if (sellingplan) {
              item.selling_plan = sellingplan;
            }
        
  
            items.push(item);
          }
        });
        // 4. If all quantities <= 0, alert
        if (!hasValidQty) {
       
              if(inputContainer){
                inputContainer.classList.add("is--error");
                inputContainer.scrollIntoView({
                  behavior: 'smooth', // smooth scrolling animation
                  block: 'start'      // align the top of element with the top of viewport
                });
              }
  
                const errorEl = document.createElement('div');
                errorEl.className = 'custom-error-message';
                errorEl.textContent = 'Please select at least one item with quantity greater than 0.';
  
                // Optional styling
                errorEl.style.color = 'red';
                errorEl.style.marginBottom = '10px';
                errorEl.style.fontWeight = '500';
  
                // Insert before the button
                btn.parentNode.insertBefore(errorEl, btn);       
          return;
        }
               btn.classList.add("is--loading");
              // 5. Add to cart via fetch
              fetch(window.Shopify.routes.root + "cart/add.js", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  "Accept": "application/json"
                },
                body: JSON.stringify({ items })
              })
                .then((res) => res.json())
                .then((data) => {
                    //  btn.classList.remove("is--loading");
                      window.location.href = "/cart";
                })
                .catch((err) => {
                  btn.classList.remove("is--loading");
                  const errorEl = document.createElement('div');
                  errorEl.className = 'custom-error-message';
                  errorEl.textContent = 'Something went wrong. Please try again.';
  
                  // Optional styling
                  errorEl.style.color = 'red';
                  errorEl.style.marginBottom = '10px';
                  errorEl.style.fontWeight = '500';
  
                  // Insert before the button
                  btn.parentNode.insertBefore(errorEl, btn);
                // alert("Something went wrong. Please try again.");
                });
      });
    });
  });

  // Update add-to-cart button text with price and "1 FREE" when applicable
  // Only applies to site_b2g1_pdp product pages
  document.addEventListener("DOMContentLoaded", function () {
    // Check if this is a B2G1 product page
    const b2g1Page = document.querySelector("product-page.site_b2g1_pdp");
    if (!b2g1Page) return; // Exit if not a B2G1 page
    
    function updateAddToCartButtonText() {
      // Get all quantity selects
      const qtyInputs = document.querySelectorAll(".cm-variant-qty");
      if (qtyInputs.length === 0) return;

      // Calculate total price and total quantity
      let totalPriceFull = 0; // Price if all items were paid
      let totalQty = 0;
      const GLOBAL_DISCOUNT_FACTOR = window.GLOBAL_DISCOUNT_FACTOR || 1;

      // Calculate totals from variant items
      qtyInputs.forEach(function(qtyInput) {
        const qty = parseInt(qtyInput.value, 10) || 0;
        totalQty += qty;
        
        const itemWrapper = qtyInput.closest(".cm-variant-item");
        if (itemWrapper && qty > 0) {
          // Get price from data attribute
          const variantPriceAttr = itemWrapper.getAttribute("data-variant-price");
          if (variantPriceAttr) {
            const variantPrice = parseFloat(variantPriceAttr);
            // Apply discount factor and convert from cents to dollars
            const price = (variantPrice * GLOBAL_DISCOUNT_FACTOR) / 100;
            totalPriceFull += price * qty;
          }
        }
      });

      // Apply "Buy 2 Get 1 Free" promotion
      // For every 3 items, charge for 2 (3rd, 6th, 9th, etc. are free)
      const freeQty = Math.floor(totalQty / 3); // Number of free items
      const chargeableQty = totalQty - freeQty; // Number of items to charge for
      
      // Calculate average price per item
      const avgPricePerItem = totalQty > 0 ? totalPriceFull / totalQty : 0;
      
      // Calculate actual price to charge (chargeable quantity * average price)
      const totalPrice = chargeableQty * avgPricePerItem;

      // Get base button text (only for cm-add-to-cart buttons within multi-variant forms)
      const form = qtyInputs[0] ? qtyInputs[0].closest("form") : null;
      if (!form) return;
      
      const buttonTextElements = form.querySelectorAll(".cm-add-to-cart [data-js-product-add-to-cart-text]");
      if (buttonTextElements.length === 0) return;

      // Get the original button text (stored in data attribute if not already set)
      buttonTextElements.forEach(function(textEl) {
        if (!textEl.hasAttribute("data-original-text")) {
          textEl.setAttribute("data-original-text", textEl.textContent.trim());
        }
        const baseText = textEl.getAttribute("data-original-text") || "Add to cart";
        
        // Build new text with price
        let newText = baseText;
        if (totalQty > 0 && totalPrice > 0) {
          newText = baseText + " → $" + totalPrice.toFixed(2);
          // Add free items text if applicable
          if (freeQty > 0) {
            newText += " + " + freeQty + " FREE";
          }
        } else {
          // Reset to original text if no items selected
          newText = baseText;
        }
        
        textEl.textContent = newText;
      });

      // Promo label below button: show message when qty is 1 or 2
      const addToCartBtn = form.querySelector(".cm-add-to-cart");
      if (addToCartBtn) {
        let promoLabel = form.querySelector("[data-b2g1-promo-label]");
        if (!promoLabel) {
          promoLabel = document.createElement("p");
          promoLabel.setAttribute("data-b2g1-promo-label", "");
          promoLabel.className = "b2g1-promo-label";
          addToCartBtn.parentNode.insertBefore(promoLabel, addToCartBtn.nextSibling);
        }
        if (totalQty === 1) {
          promoLabel.textContent = "Add one more bag to qualify for a free one!";
          promoLabel.style.display = "";
        } else if (totalQty === 2) {
          promoLabel.textContent = "Don't forget to add your free bag!";
          promoLabel.style.display = "";
        } else if (totalQty > 2) {
          promoLabel.textContent = "You're getting a free bag of planta!";
          promoLabel.style.display = "";
        } else {
          promoLabel.style.display = "none";
        }
      }
    }

    // Listen for quantity changes
    document.querySelectorAll(".cm-variant-qty").forEach(function(qtyInput) {
      qtyInput.addEventListener("change", updateAddToCartButtonText);
    });

    // Initial update
    setTimeout(updateAddToCartButtonText, 500);
  });
  
  
  document.querySelectorAll('a[href*="#faqs-section"]').forEach(link => {
    link.addEventListener('click', e => {
         var checkfaq = movetofaq();
          if(!checkfaq){
                e.preventDefault();
  
          }
    });
  });
  
  /*********************
   FREEBIES PROGRESS BAR CONTROLLER
   - does NOT replace existing listeners
   - just adds its own listeners + updater
  *********************/
  document.addEventListener("DOMContentLoaded", function () {
  
    // 1. Get total qty selected in the multi-variant grid
    function getSelectedQtyTotal() {
      let total = 0;
      document.querySelectorAll(".cm-variant-qty").forEach(function (qtyInput) {
        let qty = parseInt(qtyInput.value, 10) || 0;
        total += qty;
      });
      return total;
    }
  
    // 2. Update the text + image under the Key Benefits section
    function updateFreebiesProgressUI() {
  
      const wrapper = document.getElementById("pgbar_response");
      const msgEl = document.getElementById("freebies_progress_msg");
      const fillEl = document.getElementById("freebies_progress_fill");
    
      if (!wrapper || !msgEl || !fillEl) return;
    
      let totalQty = getSelectedQtyTotal();
    
      // Clamp value to 4 max
      if (totalQty > 3) totalQty = 3;
    
      // Get messages from data attributes, with fallback defaults
      const progressMap = {
        0: { 
          percent: 0, 
          text: wrapper.getAttribute("data-progress-msg-0") || "Buy 2 more to get free shipping" 
        },
        1: { 
          percent: 30, 
          text: wrapper.getAttribute("data-progress-msg-1") || "Buy 1 more to get free shipping" 
        },
        2: { 
          percent: 70, 
          text: wrapper.getAttribute("data-progress-msg-2") || "Add one more bag to get 10% off" 
        },
        3: { 
          percent: 100, 
          text: wrapper.getAttribute("data-progress-msg-3") || "🎉 CONGRATS! YOU'VE UNLOCKED ALL REWARDS!" 
        },
      };
    
      const step = progressMap[totalQty];
  
      fillEl.style.width = step.percent + "%";
      msgEl.textContent = step.text;
    }
    
  
    function specialFuncionlity() {
      const pgbar_response = document.querySelector("#pgbar_response");
      const currentquantity = parseInt(pgbar_response.getAttribute("data-cartcount"), 10) || 0;
    
      let addedQty = 0;
    
      document.querySelectorAll(".cm-variant-qty").forEach(function (qtyInput) {
        const qty = parseInt(qtyInput.value, 10) || 0;
        if (qty > 0) addedQty += qty;
      });
    
      pgbar_response.setAttribute("data-cartcount", addedQty + currentquantity);
    }
    
  
    // 3. Watch all qty dropdowns for change and refresh progress bar
    function attachQtyListeners() {
      document.querySelectorAll(".cm-variant-qty").forEach(function (dropdown) {
        dropdown.addEventListener("change", function () {
          specialFuncionlity();
          updateFreebiesProgressUI();
        });
      });
      // Delegated: run when any .cm-variant-qty changes (e.g. grid rendered after DOMContentLoaded)
      document.addEventListener("change", function (e) {
        if (e.target.matches && e.target.matches(".cm-variant-qty")) {
          specialFuncionlity();
          updateFreebiesProgressUI();
        }
      });
    }
  
    // 4. Initialize on load
    attachQtyListeners();
    updateFreebiesProgressUI();
  });
  
  // ===== HPN: Preselect variant via ?preselect=VARIANT_ID, else default Banana Maple =====
  (function preselectOrDefaultQty(){
    // Fallback default → Banana Maple French Toast
    let FALLBACK_DEFAULT_VARIANT_ID = document.querySelector('product-form').getAttribute('default-variant-id');
  
    // Read ?preselect=123 from URL (only digits allowed)
    let urlParams = new URLSearchParams(window.location.search);
    let paramId = urlParams.get('preselect');
    let PRESELECT_ID = (paramId && /^\d+$/.test(paramId)) ? paramId : null;
  
    function setQtyOneIfZeroByVariantId(variantId){
      if (!variantId) return false;
      
      let item = document.querySelector('.cm-variant-item[data-variant-id="' + variantId + '"]');
      if (!item) return false;
      
      let qtyEl = item.querySelector('.cm-variant-qty');
      if (!qtyEl) return false;
      
      let curr = parseInt(qtyEl.value, 10) || 0;
      if (curr < 1){
        qtyEl.value = '1';
        // trigger change so all listeners (progress bar, image switcher) update
        qtyEl.dispatchEvent(new Event('change', { bubbles: true }));
      }
  
      // ensure item is visible inside the horizontal scroll container
      let container = item.closest('.cm-variants-grid');
      if (container && container.scrollWidth > container.clientWidth) {
  
        const itemLeft  = item.offsetLeft;
        const itemRight = item.offsetLeft + item.offsetWidth;
  
        const viewLeft  = container.scrollLeft;
        const viewRight = container.scrollLeft + container.clientWidth;
  
        let nextScrollLeft = container.scrollLeft;
  
        // item is left of visible area
        if (itemLeft < viewLeft) {
          nextScrollLeft = itemLeft;
        }
  
        // item is right of visible area
        else if (itemRight > viewRight) {
          nextScrollLeft = (itemRight - container.clientWidth) * 10;
        }
  
        console.log(nextScrollLeft, 'nextScrollLeft');
  
        container.scrollTo({
          left: nextScrollLeft,
          behavior: 'smooth'
        });
      }
  
      return true;
    }
  
    function init(){
      // If a valid preselect is present AND we can find that variant, use it and stop.
      if (PRESELECT_ID && setQtyOneIfZeroByVariantId(PRESELECT_ID)) {
        return;
      }
      // Else fallback to Banana Maple
      setQtyOneIfZeroByVariantId(FALLBACK_DEFAULT_VARIANT_ID);
    }
  
    if (document.readyState === 'loading'){
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  
  
  // ===== HPN: Switch main gallery image when qty is set (>0) for a variant [v2 robust] =====
  (function variantQtyImageSwitcherV2(){
    // Map Variant ID -> unique image slug (substring in its CDN URL)
    let VARIANT_IMG_SLUG = {
      "40461385531477": "BananaMapleFrenchToast",
      "40472683675733": "ChocolateCaramelCandyBar_97b05662-1916-4077-9b4b-0770e21c0884",
      "40549946589269": "CinnamonRoll",
      "40550495191125": "MadagascarVanilla_891ff9ac-ad16-4498-908a-35304225ea3f",
      "40613658165333": "MeltedChocolate_7be8f52b-db42-405a-85b2-030da2d61d66",
      "40722836947029": "StrawberryIceCream_1d9b8de5-7102-4bca-9aee-96d48f9797a7"
    };
  
    // 1) Prefer moving the Splide thumbnail rail
    function goThumbBySlug(slug){
      try{
        if (!window._site1Thumbs || !slug) return false;
        let slides = document.querySelectorAll('#thumbnail-slider .splide__slide');
        if (!slides.length) return false;
  
        let targetIndex = -1;
        for (let i=0;i<slides.length;i++){
          let img = slides[i].querySelector('img');
          if (img && (img.currentSrc || img.src)){
            let src = img.currentSrc || img.src;
            if (src.indexOf(slug) !== -1){ targetIndex = i; break; }
          }
        }
        if (targetIndex >= 0){
          window._site1Thumbs.go(targetIndex);
          return true;
        }
      }catch(e){}
      return false;
    }
  
    // 2) Fallbacks if Splide not available
    function switchMainSrc(src){
      if (!src) return;
      let mainImg =
        document.querySelector('.product-gallery__main img') ||
        document.querySelector('.product__media img') ||
        document.querySelector('.product__media-item img') ||
        document.querySelector('.product__main-photos img') ||
        document.querySelector('#ProductPhotos img') ||
        document.querySelector('.product-gallery img');
      if (mainImg){
        mainImg.src = src;
        if (mainImg.srcset) mainImg.srcset = src;
      }
    }
  
    // NEW: Switch the main CSS Slider panel by media id or variant id (thumbnails / qty sync)
    function activateCssSliderByMediaId(mediaOrVariantId, fromElement) {
      if (!mediaOrVariantId) return false;
      var gallery = (fromElement && fromElement.closest('.product-gallery')) ||
        (fromElement && fromElement.closest('[data-js-product-gallery]')) ||
        document.querySelector('.product-gallery') ||
        document.querySelector('[data-js-product-gallery]');
      if (!gallery) return false;
      var slider = gallery.querySelector('css-slider');
      if (!slider) return false;
      var slide = slider.querySelector('.product-gallery-item[data-media-id="' + mediaOrVariantId + '"]') ||
        slider.querySelector('.product-gallery-item[data-variant-id="' + mediaOrVariantId + '"]');
      if (!slide) return false;
      var slides = slider.querySelectorAll('.product-gallery-item.css-slide, .product-gallery-item');
      var index = Array.prototype.indexOf.call(slides, slide);
      if (index < 0) return false;
      if (typeof slider.changeSlide === 'function') {
        slider.changeSlide(index, 'auto');
        return true;
      }
      return false;
    }

    // NEW: Switch the main CSS Slider panel by image slug (fallback when media/variant id not used)
    function activateCssSliderBySlug(slug){
      try{
        if (!slug) return false;
        var gallery = document.querySelector('.product-gallery') || document.querySelector('[data-js-product-gallery]');
        var slider = gallery ? gallery.querySelector('css-slider') : null;
        if (!slider) {
          slider = document.querySelector('.product-gallery .css-slider.enabled') ||
            document.querySelector('.css-slider.enabled');
        }
        if (!slider) return false;

        var slides = slider.querySelectorAll('.product-gallery-item.css-slide, .product-gallery-item');
        if (!slides.length) return false;

        var target = null;
        for (var i = 0; i < slides.length; i++) {
          var slide = slides[i];
          var img = slide.querySelector('img');
          var src = (img && (img.currentSrc || img.src)) || '';
          if (src.indexOf(slug) !== -1) { target = slide; break; }
        }
        if (!target) return false;

        var index = Array.prototype.indexOf.call(slides, target);
        if (index < 0) return false;
        if (typeof slider.changeSlide === 'function') {
          slider.changeSlide(index, 'auto');
          return true;
        }
        return false;
      } catch(err) {
        return false;
      }
    }
  
      // NEW: global helper to switch main image from a full <img> URL
    window._site1ActivateMainByImgSrc = function(src){
      if (!src) return false;
      // try filename slug (works with your css-slider matcher)
      let slug = src.split('/').pop().split('?')[0];
      if (activateCssSliderBySlug(slug)) return true;
      // fallback: hard swap the main <img> if present
      switchMainSrc(src);
      return true;
    };

    // NEW: global helper to switch main image by media id (used by thumbnail clicks)
    window._site1ActivateMainByMediaId = function(mediaId, fromElement) {
      return activateCssSliderByMediaId(mediaId, fromElement);
    };
  
  
    // Simplified: drive main image directly from variant (qty change) or image URL
    function handleQtyChange(target){
      if (!target || !target.matches('.cm-variant-qty')) return;

      var qty = parseInt(target.value, 10) || 0;
      if (qty <= 0) return;

      var item = target.closest('.cm-variant-item');
      if (!item) return;

      var variantId = item.getAttribute('data-variant-id');
      if (variantId && window._site1ActivateMainByMediaId) {
        if (window._site1ActivateMainByMediaId(variantId)) return;
      }

      // Fallback: use image URL (data-alt-img or img in card)
      var src = item.getAttribute('data-alt-img');
      if (!src) {
        var img = item.querySelector('img');
        src = img && (img.currentSrc || img.src);
      }
      if (src && window._site1ActivateMainByImgSrc) {
        window._site1ActivateMainByImgSrc(src);
      }
    }
  
    // Change listener for qty selects
    document.addEventListener('change', function(e){
      handleQtyChange(e.target);
    });
  
    // On load, if any qty > 0 (e.g., your default Banana Maple 1), sync image
    function syncOnLoad(){
      let firstPositive = null;
      document.querySelectorAll('.cm-variant-qty').forEach(function(q){
        let v = parseInt(q.value,10) || 0;
        if (!firstPositive && v > 0) firstPositive = q;
      });
      if (firstPositive) handleQtyChange(firstPositive);
    }
  
    if (document.readyState === 'loading'){
      document.addEventListener('DOMContentLoaded', syncOnLoad);
    } else {
      syncOnLoad();
    }
  })();
  